import { useHistory, useLocation } from 'react-router-dom';
import { Tabs, Tab } from '@material-ui/core';

const NAV_TABS = [
  { label: 'Histórico', path: '/app/notifications' },
  { label: 'Grupos', path: '/app/notifications/user-groups' }
];

export function NotificationNav() {
  const history = useHistory();
  const location = useLocation();

  const activeTab = location.pathname.startsWith('/app/notifications/user-groups') ? 1 : 0;

  const handleChange = (_, newValue) => {
    history.push(NAV_TABS[newValue].path);
  };

  return (
    <Tabs value={activeTab} onChange={handleChange} indicatorColor="primary" textColor="primary">
      {NAV_TABS.map((tab) => (
        <Tab key={tab.path} label={tab.label} />
      ))}
    </Tabs>
  );
}
